import React, { createContext, useState } from "react";
import jwt_decode from 'jwt-decode';



export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));


  const login = (token) => {
    const decoded = jwt_decode(token);

    setToken(token);
    setRole(decoded.role);
    localStorage.setItem("token", token);
    localStorage.setItem("role", decoded.role);
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    localStorage.clear();
  };

  const isAuthenticated = () => !!token;

  return (
    <AuthContext.Provider value={{ token, role, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
